export const extractCoinPageTitle = (str: Maybe<string>): Maybe<string> => {
  if (!str) return null;

  const parts = str.split('|').map(part => part.trim());
  const titlePart = parts.find(part => part.includes(':') && !part.startsWith("{{'hidden'}}"));

  if (!titlePart) return null;

  const separator = `:`;
  const titleParts = titlePart.split(separator);

  if (titleParts.length > 1) return titleParts.slice(1).join(separator).trim();
  else if (titleParts.length === 1) return titleParts[0].trim();
  else return null;
};